import CrudTemplate from "../crudTemplate";
import CidadeService from "../../services/resource/cidadeService";
import EstadoService from "../../services/resource/estadoService";
import { useEffect, useState } from "react";

export default function CidadeCrud() {
    const service = new CidadeService();
    const estadoService = new EstadoService();

    const [estados, setEstados] = useState([]);

    useEffect(() => {
        estadoService.listar().then(res => setEstados(res.data)).catch(e => console.error(e));
    },[])

    const formFields = [
        {
            name: "id",
            label: "CódigoD",
            type: "input",
            disabled: true,
            typeText: "number",
            colSpan: 1
        },
        {
            name: "nome",
            label: "Nome",
            type: "input",
            colSpan: 1
        },
        {
            name: "estadoId",
            label: "Estado",
            type: "dropdown",
            options: estados,
            optionLabel: "nome",
            optionValue: "id",
            colSpan: 1
        }
    ];

    const tableColumns = [
        { key: "id", label: "Código", bold: true },
        { key: "nome", label: "Nome", bold: true },
        { key: "estadoNome", label: "Estado"},
    ];

    return <CrudTemplate
        title="Gerenciar Cidades"
        formFields={formFields}
        tableColumns={tableColumns}
        service={service}
        style={{ width: '85%' }}
        modalHeader="Cidade"
    />;
}
